import { useContext, useState } from 'react'
import { Box, Typography, Paper, Checkbox, FormControlLabel, Button } from '@mui/material'
import { AuthContext } from '../../contexts/auth/authContext'
import { DataContext } from '../../contexts/data/dataContext'
import { useGetCurrentSession } from '../../services/api-query/auth'
import { useGetDirectDebitConsent } from '../../services/api-query/directDebit'
import Notification from '../common/notification'

import custom from '../../styles/mui/szVariables.json'

const DirectDebitStep2 = ({ onContinue }: any) => {
  const data = useContext(DataContext)
  const auth = useContext(AuthContext)
  const { currentSession } = useGetCurrentSession()
  const { consent } = useGetDirectDebitConsent(currentSession)
  const [staffError, setStaffError] = useState('')
  const [checkboxes, setCheckboxes] = useState({
    operate: false,
    agree: false,
    authorise: false,
  })

  const handleCheckboxChange = (e: any) => {
    setCheckboxes({
      ...checkboxes,
      [e.target.name]: e.target.checked,
    })
  }

  const handleConfirmDirectDebit = ()=>{
    if(!auth?.staff) {
      data?.updateDirectDebit()
      .then(()=>onContinue())
    } else {
      setStaffError("You cannot perform this action while impersonating")
    }
  }

  const allChecked = Object.values(checkboxes).every(Boolean)

  return (
    <Box display="flex"
        flexDirection="column" 
        justifyContent="center" 
        alignItems="flex-left" 
        maxWidth={"100%"}
        p={custom.spacing.md}>
      <Typography variant="szHeading.Bold.xxSmall">
          Terms and conditions
      </Typography>
      <Paper elevation={1} sx={{ 
          border: custom.border,
          boxSizing: 'border-box',
          borderRadius: custom.corners4,
          p: custom.spacing.sm, 
          mt: custom.spacing.sm, 
          mb: custom.spacing.lg, 
          maxHeight: 200, 
          overflow: 'auto' 
        }}>
        <Typography paragraph id='tAndcTitle'
          variant="szBody.Regular.Medium">
          {consent?.termsAndConditions?.title}
        </Typography>
        {consent?.termsAndConditions?.text?.split('\n')
          .map((paragraph: any, index: any) => (
          <Typography key={index} id={'tAndcLine'+(index+1)}
            paragraph variant="szBody.Regular.Small">
            {paragraph}
          </Typography>
        ))}
      </Paper>
      <Typography variant="szHeading.Bold.xxSmall">
        Please confirm the following details
      </Typography>
      <FormControlLabel
        sx={{ 
          mt: custom.spacing.sm, 
          mb: custom.spacing.xxs 
        }}
        control={<Checkbox 
                  checked={checkboxes.operate} 
                  onChange={handleCheckboxChange} 
                  name="operate" 
                  id="operate"
                  />}
        label={<Typography 
                variant="szBody.Regular.Small">
                  {consent?.consents[0]?.text}
                </Typography>
              }
      />
      <FormControlLabel
        sx={{ mb: custom.spacing.xxs }}
        control={<Checkbox 
                  checked={checkboxes.agree} 
                  onChange={handleCheckboxChange} 
                  name="agree" 
                  id="agree"
                  />}
        label={<Typography 
                variant="szBody.Regular.Small">
                {consent?.consents[1]?.text}
              </Typography>}
      />
      <FormControlLabel
        control={<Checkbox 
                  checked={checkboxes.authorise} 
                  onChange={handleCheckboxChange} 
                  name="authorise" 
                  id="authorize"
                  />}
        label={<Typography 
                variant="szBody.Regular.Small">
                  {consent?.consents[2]?.text}
                </Typography>}
      />

      <Box sx={{ mt: custom.spacing.lg, mb:  custom.spacing.sm }}>
        <Button 
          id="confirmDirectDebit"
          variant="contained" 
          fullWidth 
          disabled={!allChecked} 
          onClick={handleConfirmDirectDebit}>
          Confirm
        </Button>
      </Box>
      <Notification 
        title={"Error"} 
        message={staffError}
        type="error"
        setError={setStaffError}
        hposition="center"
        />
    </Box>
    
  )
}

export default DirectDebitStep2
